import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UtmParams {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
  utmId?: string;
  utmCampaignDate?: string;
}

const initialState: UtmParams = {};

const utmSlice = createSlice({
  name: 'utm',
  initialState,
  reducers: {
    setUtmParams: (state, action: PayloadAction<UtmParams>) => ({ ...state, ...action.payload }),
    clearUtmParams: () => ({}),
  },
});

export const { actions, reducer } = utmSlice;
